<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ isEdit ? 'Edit campaign' : 'Add campaign'}}</p>
    </header>

    <section class="modal-card-body">
      <b-field label="Name:">
        <b-input type="text" v-model="name" placeholder="Campaign name"></b-input>
      </b-field>
      <b-field v-if="nameError" style="color: red">
      Please enter a name.
    </b-field>
      <b-field label="Playlist:">
      <b-select v-model="selectedPlaylist">
      <option  value="">-- Choose a playlist --</option>
              <option v-for="(playlist, id) of playlists" :key="id" :value="id">
                {{playlist.name}}
              </option>
            </b-select>
</b-field>
<b-field v-if="playlistError" style="color: red">
      Please select a playlist.
    </b-field>
      <b-field label="Type:">
      <b-select v-model="selectedType">
              <option v-for="(type, id) of types" :key="id" :value="type.id">
                {{type.name}}
              </option>
            </b-select>
</b-field>
<b-field label="Date range">
<b-datepicker
            placeholder="Click to select..."
            v-model="dates"
            range>
        </b-datepicker>
</b-field>
<b-field v-if="dateError" style="color: red">
      Please select a date range.
    </b-field>

    <b-field v-if="weekdaysError" style="color: red">
      The selected date range does not contain a weekday.
    </b-field>

    <b-field v-if="weekendError" style="color: red">
      The selected date range does not contain a weekend day.
    </b-field>

   <b-field label="Start time:">
    <b-timepicker
    v-model="startTime"
                rounded
                placeholder="Click to select..."
                icon="clock"
                :enable-seconds="secs"
                hour-format="24"
                locale="es-ES">
            </b-timepicker>
    </b-field>

    <b-field v-if="startTimeError" style="color: red">
      Please enter a start time.
    </b-field>

    <b-field label="End time:">
    <b-timepicker
                v-model="endTime"
                rounded
                placeholder="Click to select..."
                icon="clock"
                :enable-seconds="secs"
                hour-format="24"
                :locale="locale"
                position="is-top-right">
            </b-timepicker>
    </b-field>

<b-field v-if="endTimeError" style="color: red">
      Please enter an end time.
    </b-field>

    <b-field v-if="timesError1" style="color: red">
      End time cannot be before start time.
    </b-field>

    <b-field v-if="timesError2" style="color: red">
      End time cannot be same as start time.
    </b-field>

    </section>

    <footer class="modal-card-foot">
      <b-button type="is-info" @click="saveCampaign">Save</b-button>
      <b-button type="is-light" @click="$parent.close()">Cancel</b-button>
    </footer>
  </div>
</template>

<script>

export default {
  name: 'CampaignAddEdit',
  props: ['propParentFn', 'isEdit', 'campToEdit', 'editCampaignId', 'editCampaignIndex'], // tuka bese clusterId
  /* components: {
    vuePlayer
  }, */
  computed: {
    playlists () {
      return this.$store.state.playlists
    }
  },
  data: () => {
    return {
      // types: ['Every day', 'Week days', 'Weekend'],
      types: [{ id: 1, name: 'Every day' }, { id: 2, name: 'Weekdays' }, { id: 3, name: 'Weekend' }],
      selectedType: 1,
      selectedPlaylist: null,
      name: null,
      dates: [],
      secs: false,
      startTime: null,
      endTime: null,
      locale: 'es-ES',
      nameError: false,
      dateError: false,
      startTimeError: false,
      endTimeError: false,
      playlistError: false,
      timesError1: false,
      timesError2: false,
      weekdaysError: false,
      weekendError: false
    }
  },
  mounted: function () {
    if (this.isEdit) {
      this.name = this.campToEdit.name
      this.selectedPlaylist = this.campToEdit.playlistId
      this.selectedType = this.campToEdit.type
      var startDateArray = this.campToEdit.startDate.split('.')
      var startD = new Date(startDateArray[2], parseInt(startDateArray[1]) - 1, startDateArray[0])
      var endDateArray = this.campToEdit.endDate.split('.')
      var endD = new Date(endDateArray[2], parseInt(endDateArray[1]) - 1, endDateArray[0])
      this.dates = [startD, endD]
      this.startTime = new Date(2000, 12, 12, this.campToEdit.startTime.split(':')[0], this.campToEdit.startTime.split(':')[1], 0)
      this.endTime = new Date(2000, 12, 12, this.campToEdit.endTime.split(':')[0], this.campToEdit.endTime.split(':')[1], 0)
    } else {
      const firstKey = Object.keys(this.playlists)[0]
      this.selectedPlaylist = firstKey
    }
  },
  methods: {
    saveCampaign () {
      this.nameError = false
      this.dateError = false
      this.startTimeError = false
      this.endTimeError = false
      this.playlistError = false
      this.timesError1 = false
      this.timesError2 = false
      this.weekdaysError = false
      this.weekendError = false
      this.globalLogger('HERE')
      if (this.name === null || this.name === '') {
        this.nameError = true
      } else if (this.selectedPlaylist === '' || this.selectedPlaylist === null) {
        this.playlistError = true
      } else if (this.dates.length === 0) {
        this.dateError = true
      } else if (this.startTime === null) {
        this.startTimeError = true
      } else if (this.endTime === null) {
        this.endTimeError = true
      } else if (this.selectedType === 2 && !this.checkWeekdays()) {
        this.weekdaysError = true
      } else if (this.selectedType === 3 && !this.checkWeekend()) {
        this.weekendError = true
      } else if (this.startTime > this.endTime) {
        this.timesError1 = true
      } else if (this.startTime.getHours() === this.endTime.getHours() && this.startTime.getMinutes() === this.endTime.getMinutes()) {
        this.timesError2 = true
      } else {
        var stArray = null
        var endArray = null
        let stTime = this.startTime.toString().split(' ')[4].split(':')
        let enTime = this.endTime.toString().split(' ')[4].split(':')
        let stDate = this.dates[0].toLocaleDateString('en-US')
        let enDate = this.dates[1].toLocaleDateString('en-US')
        stArray = stDate.split('/')
        endArray = enDate.split('/')
        if (stArray[0].length === 1) {
          stArray[0] = '0' + stArray[0]
        }
        if (stArray[1].length === 1) {
          stArray[1] = '0' + stArray[1]
        }
        stDate = stArray[1] + '.' + stArray[0] + '.' + stArray[2]
        if (endArray[0].length === 1) {
          endArray[0] = '0' + endArray[0]
        }
        if (endArray[1].length === 1) {
          endArray[1] = '0' + endArray[1]
        }
        enDate = endArray[1] + '.' + endArray[0] + '.' + endArray[2]
        let campaign = {
          name: this.name,
          playlistId: this.selectedPlaylist,
          type: this.selectedType,
          startTime: stTime[0] + ':' + stTime[1],
          endTime: enTime[0] + ':' + enTime[1],
          startDate: stDate,
          endDate: enDate
        }
        if (this.isEdit) {
          this.globalLogger(campaign, 'campaign in child edit')
          this.propParentFn(campaign, this.editCampaignId, this.editCampaignIndex)
        } else {
          this.globalLogger(campaign, 'campaign in child add')
          this.propParentFn(campaign)
        }
        this.$parent.close()
      }
    },
    checkWeekdays () {
      var startDateCopy = this.dates[0]
      var endDate = this.dates[1]
      while (startDateCopy <= endDate) {
        this.globalLogger('vo while')
        const dayOfWeek = startDateCopy.getDay()
        this.globalLogger(dayOfWeek)
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          return true
        }
        let incrementedDate = startDateCopy.setDate(startDateCopy.getDate() + 1)
        startDateCopy = new Date(incrementedDate)
        this.globalLogger('COPYY: ', startDateCopy)
      }
      return false
    },
    checkWeekend () {
      var startDateCopy = this.dates[0]
      var endDate = this.dates[1]
      while (startDateCopy <= endDate) {
        this.globalLogger('vo while')
        const dayOfWeek = startDateCopy.getDay()
        this.globalLogger(dayOfWeek)
        if (dayOfWeek === 0 || dayOfWeek === 6) {
          return true
        }
        let incrementedDate = startDateCopy.setDate(startDateCopy.getDate() + 1)
        startDateCopy = new Date(incrementedDate)
        this.globalLogger('COPYY: ', startDateCopy)
      }
      return false
    },
    closeModal () {
      if (this.propParentFn) {
        this.propParentFn()
      }
      this.$parent.close()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/clusters/campaigns/CampaignAddEdit.vue